import {
  ExtAdapter,
  ExtError,
  ExtFrameMessage,
  ExtInteractingError,
  ExtInternalError,
  ExtNotSupportError,
  ExtParamInvalidError,
  ExtRejectAuthError,
  HandleFrameMessageResp,
  getExtVersionTag,
  service,
  trimHttp,
  unescapeHTML,
  wasmGenUnionId,
} from '@hyext-inner/ext-web-comp'
import { InnerExtEndpointModule } from '@hyext-inner/inner-ext-web-comp'
import md5 from 'md5'
import {
  BusType,
  EventName,
  HyTafFuncName,
  HyTafUI,
  HyVideoState,
  TTPCallFuncName,
} from '../../util/hy'
import { HyPostMessageTopic, TTPEventName } from '../../util/hy'
import {
  showLeadBarrageModal,
  showLeadGiftModal,
  showLeadSubscribeModal,
  showOpenCoinExchangeModal,
  showRequestConsumeModal,
  showSendGiftModal,
} from '../../views/HyExtModal'
import HyExtAdapter from '../adapters/HyExtAdapter'
import HyExtAdapterInLiveRoom from '../adapters/HyExtAdapterInLiveRoom'
import { v4 } from 'uuid'
import { Topic } from '@hyext-inner/ext-web-comp/dist/ext/ExtFrameMessage'
import { report } from '../../util/tracking'

let isSendingGift = false

const fileContentMap: {
  [key: string]: {
    file: File
    contentMD5: string
  }
} = {}

export default abstract class HyExtEndpointModule extends InnerExtEndpointModule {
  // 重载initBusiFrame，添加性能数据
  initBusiFrame(adapter: ExtAdapter, query?: string): Promise<void> {
    // 获取性能数据
    let benchmarkFps = 0
    let benchmarkCpuScore = 0
    try {
      benchmarkFps = Number(localStorage.getItem('benchmark-fps')) || 0
      benchmarkCpuScore =
        Number(localStorage.getItem('benchmark-cpuScore')) || 0
    } catch (err) {}

    return super.initBusiFrame(
      adapter,
      `benchmarkFps=${benchmarkFps}&benchmarkCpuScore=${benchmarkCpuScore}${
        query ? '&' + query : ''
      }`
    )
  }
  async handleFrameMessage(
    msg: ExtFrameMessage,
    adapter: ExtAdapter
  ): Promise<HandleFrameMessageResp> {
    if (msg.topic === Topic.SUP_READY) {
      this.emit('supFrameReady')
    }
    return super.handleFrameMessage(msg, adapter)
  }
  postMatchStatusChange(notice: any, adapter: ExtAdapter) {
    return this.postContextMessage(
      TTPEventName.MATCH_STATUS_CHANGE,
      notice,
      adapter
    )
  }
  postPerspectiveChange(notice: any, adapter: ExtAdapter) {
    return this.postContextMessage(
      TTPEventName.PERSPECTIVE_CHANGE,
      notice,
      adapter
    )
  }
  postObMatchEnd(notice: any, adapter: ExtAdapter) {
    return this.postContextMessage(TTPEventName.OB_MATCH_END, notice, adapter)
  }
  postObMatchBegin(notice: any, adapter: ExtAdapter) {
    return this.postContextMessage(TTPEventName.OB_MATCH_BEGIN, notice, adapter)
  }
  postVideoFrameReduceEnd(notice: any, adapter: ExtAdapter) {
    return this.postContextMessage(
      TTPEventName.VIDEO_FRAME_REDUCE_END,
      notice,
      adapter
    )
  }
  postVideoFrameReduceStart(notice: any, adapter: ExtAdapter) {
    return this.postContextMessage(
      TTPEventName.VIDEO_FRAME_REDUCE_START,
      notice,
      adapter
    )
  }
  postViewportChange(notice: any, adapter: ExtAdapter) {
    return this.postContextMessage(
      TTPEventName.VIEW_PORT_CHANGE,
      notice,
      adapter
    )
  }
  postEndLive(adapter: ExtAdapter) {
    return this.postContextMessage(TTPEventName.END_LIVE, {}, adapter)
  }
  postBeginLive(adapter: ExtAdapter) {
    return this.postContextMessage(TTPEventName.BEGIN_LIVE, {}, adapter)
  }
  postSubscribeChange(state: boolean, adapter: ExtAdapter) {
    return this.postContextMessage(
      HyPostMessageTopic.SUBSCRIBE_SUBMIT,
      state,
      adapter
    )
  }
  postVideoEvent(type: string, adapter: ExtAdapter) {
    const funcName = 'hyExt.player.on'
    const apiAuth = this.extEndpoint.typeAuthority.apiAuthority.value.find(
      (a) => a.apiName === funcName
    )
    if (!apiAuth || apiAuth.usable === 1) {
      this.extFrame.postMessageToBusiFrame(
        HyPostMessageTopic.PLAYER,
        {
          event: type,
        },
        adapter
      )
    }
  }
  async postBarrageSubmit(barrageInfo: BarrageInfo, adapter: ExtAdapter) {
    return this.postContextMessage(
      HyPostMessageTopic.BARRAGE_SUBMIT,
      barrageInfo,
      adapter
    )
  }
  async postGiftSubmit(giftInfo: GiftInfo, adapter: ExtAdapter) {
    return this.postContextMessage(
      HyPostMessageTopic.GIFT_SUBMIT,
      giftInfo,
      adapter
    )
  }
  async postVideoStateChange(
    notice: { state: HyVideoState },
    adapter: ExtAdapter
  ) {
    return this.postContextMessage(
      HyPostMessageTopic.VIDEO_STATE_CHANGE,
      notice,
      adapter
    )
  }
  async postControlStatusChange(
    notice: { visibility: boolean },
    adapter: ExtAdapter
  ) {
    return this.postContextMessage(
      HyPostMessageTopic.UI_VISIBILITY_STATE_CHANGE,
      notice,
      adapter
    )
  }
  // 业务方法
  log(req: LogReq) {
    // @ts-ignore
    this.logger[req.level](req.msg)
    return Promise.resolve()
  }
  async hySendGift(
    uid: number,
    giftId: number,
    giftCount: number,
    adapter: ExtAdapter,
    isAdvance: boolean,
    sSrcType: string,
    extUuid: string,
    extType: string
  ) {
    const dim = {
      uid: '',
      pid: `${adapter.getStreamerUid()}`,
      room_id: `${adapter.getRoomId()}`,
      env:
        process.env.BUILD_MODE === 'prod'
          ? 'prod'
          : process.env.BUILD_MODE === 'test'
          ? 'test'
          : 'dev',
      ext_uuid: extUuid,
      ext_type: extType,
      is_advance: isAdvance ? '1' : '0',
      target_uid: `${uid}`,
      gift_id: `${giftId}`,
      gift_count: `${giftCount}`,
      msg: '',
    }
    const field = {
      // Counter
      fail_by_is_sending_gift: 0,
      get_jwt: 0,
      get_jwt_succ: 0,
      get_gift_data: 0,
      get_gift_data_succ: 0,
      get_user_id: 0,
      get_user_id_succ: 0,
      fail_by_no_gift_info: 0,
      fail_by_is_streamer: 0,
      show_send_gift_modal: 0,
      show_send_gift_modal_succ: 0,
      fail_by_user_reject_send_gift: 0,
      send_gift_to_user: 0,
      send_gift_to_user_succ: 0,
      fail_by_send_gift_to_user: 0,
      send_gift: 0,
      send_gift_succ: 0,
      fail_by_send_gift_throws: 0,
      fail_by_total_throws: 0,
      fail_by_timeout: 0,
      total: 0,
      success: 0,
      fail: 0,
      // Gauge
      get_jwt_time: 0,
      get_gift_data_time: 0,
      get_user_id_time: 0,
      show_send_gift_modal_time: 0,
      send_gift_to_user_time: 0,
      send_gift_time: 0,
      total_time: 0,
    }
    const start = new Date().valueOf()
    const p = Promise.race([
      (async () => {
        if (isSendingGift) {
          field.fail_by_is_sending_gift = 1
          field.fail = 1
          return Promise.reject(
            new ExtNotSupportError('需要等待上一次送礼结果')
          )
        } else {
          try {
            isSendingGift = true
            const hyExtAdapter = adapter as HyExtAdapter

            const getJWTStart = new Date().valueOf()
            field.get_jwt = 1
            const { jwt } = await this.userAuth.getAuth(
              adapter,
              this.extEndpoint,
              await this.getModalContainer(adapter)
            )
            field.get_jwt_succ = 1
            field.get_jwt_time = new Date().valueOf() - getJWTStart

            const getGiftDataStart = new Date().valueOf()
            field.get_gift_data = 1
            const props = await hyExtAdapter.getGiftData()
            const giftItem = (props || []).find(
              (p) => String(giftId) === String(p.iPropsId)
            )
            field.get_gift_data_succ = 1
            field.get_gift_data_time = new Date().valueOf() - getGiftDataStart

            const getUserIdStart = new Date().valueOf()
            field.get_user_id = 1
            const { lUid } = await adapter.getUserId()
            dim.uid = `${lUid}`
            field.get_user_id_succ = 1
            field.get_user_id_time = new Date().valueOf() - getUserIdStart

            if (!isAdvance && !giftItem) {
              isSendingGift = false
              field.fail_by_no_gift_info = 1
              field.fail = 1
              return Promise.reject(
                new ExtParamInvalidError(
                  `当前直播间没有giftId为${giftId}的礼物`
                )
              )
            } else if (lUid === adapter.getStreamerUid()) {
              isSendingGift = false
              field.fail_by_is_streamer = 1
              field.fail = 1
              return Promise.reject(
                new ExtNotSupportError('主播不能给自己送礼')
              )
            } else {
              if (!isAdvance) {
                const { sPropsPic108, sPropsWeb } =
                  giftItem.vPropsIdentity.value[0] || {}
                const showSendGiftModalStart = new Date().valueOf()
                try {
                  field.show_send_gift_modal = 1
                  await showSendGiftModal({
                    extMain: this.extMain,
                    extEndpoint: this.extEndpoint,
                    container: await this.getModalContainer(adapter),
                    sendGiftInfo: {
                      giftName: giftItem.sPropsName,
                      giftCount: giftCount,
                      giftLogo: (sPropsPic108 || sPropsWeb || '').replace(
                        '&',
                        '?'
                      ),
                    },
                  })
                  field.show_send_gift_modal_succ = 1
                  field.show_send_gift_modal_time =
                    new Date().valueOf() - showSendGiftModalStart
                } catch (err) {
                  isSendingGift = false
                  field.fail_by_user_reject_send_gift = 1
                  field.show_send_gift_modal_time =
                    new Date().valueOf() - showSendGiftModalStart
                  field.fail = 1
                  return Promise.reject(new ExtRejectAuthError('用户拒绝送礼'))
                }
              }
              try {
                if (uid) {
                  const sendGiftToUserStart = new Date().valueOf()
                  field.send_gift_to_user = 1
                  const { res, msg } = await hyExtAdapter.sendGiftToUser(
                    uid,
                    giftId,
                    giftCount,
                    sSrcType
                  )
                  if (res !== 0) {
                    isSendingGift = false
                    field.fail_by_send_gift_to_user = 1
                    field.fail = 1
                    dim.msg = msg || '未知sendGiftToUser错误'
                    return Promise.reject(new ExtError(res, msg))
                  } else {
                    field.send_gift_to_user_succ = 1
                  }
                  field.send_gift_to_user_time =
                    new Date().valueOf() - sendGiftToUserStart
                } else {
                  const sendGiftStart = new Date().valueOf()
                  field.send_gift = 1
                  await hyExtAdapter.sendGift(
                    giftId,
                    giftCount,
                    isAdvance ? sSrcType : `applet_${this.extMain.extUuid}`
                  )
                  field.send_gift_succ = 1
                  field.send_gift_time = new Date().valueOf() - sendGiftStart
                }
                isSendingGift = false
                field.success = 1
                return Promise.resolve()
              } catch (err) {
                isSendingGift = false
                field.fail_by_send_gift_throws = 1
                field.fail = 1
                dim.msg = err.message || '未知sendGift错误'
                return Promise.reject(ExtError.fromError(err))
              }
            }
          } catch (err) {
            isSendingGift = false
            field.fail_by_total_throws = 1
            field.fail = 1
            dim.msg = err.message || '未知全程错误'
            return Promise.reject(new ExtInternalError('送礼失败'))
          }
        }
      })(),
      new Promise<void>((resolve, reject) => {
        setTimeout(() => {
          isSendingGift = false
          field.fail_by_timeout = 1
          field.fail = 1
          reject(new ExtInteractingError('送礼超时'))
        }, 55000)
      }),
    ])
    if (typeof p.finally === 'function') {
      return new Promise<void>((resolve, reject) =>
        p.then(resolve, reject).finally(() => {
          field.total = 1
          field.total_time = new Date().valueOf() - start
          if (process.env.BUILD_MODE !== 'prod') {
            console.log('sendGift finally', { fields: dim, dims: field })
          }
          report('hyext.sys.web.sendgift', dim, field)
        })
      )
    } else {
      return p
    }
  }
  // 消息相关
  async deliverMsg(req: DeliverMsgReq, adapter: ExtAdapter): Promise<void> {
    const { event, message } = req
    if (typeof event === 'undefined' || !String(event)) {
      return Promise.reject(new ExtParamInvalidError('event不能为空'))
    } else if (typeof message === 'undefined' || !String(message)) {
      return Promise.reject(new ExtParamInvalidError('message不能为空'))
    } else {
      const { lUid } = await adapter.getUserId()
      if (adapter.getStreamerUid() === lUid) {
        const hyExtAdapter = adapter as HyExtAdapter
        const { jwt } = await this.userAuth.getAuth(
          adapter,
          this.extEndpoint,
          await this.getModalContainer(adapter)
        )
        const MidExtCapability = await adapter.getJCE('MidExtCapability')
        const req: MidExtCapability.DeliverRoomMsgByUnionIdReq =
          new MidExtCapability.DeliverRoomMsgByUnionIdReq()
        req.appId = this.extMain.authorAppId
        req.authorization = jwt
        req.event = event
        req.extUuid = this.extMain.extUuid
        req.message = message
        req.pid = adapter.getStreamerUid()
        req.request.extVersionTag = getExtVersionTag(
          this.extMain,
          this.extEndpoint
        )
        req.request.jwt = jwt
        req.request.sHostId = adapter.getHostId()
        req.request.componentTag = this.extEndpoint.extType
        req.roomId = Number(adapter.getRoomId())
        req.tId = await adapter.getUserId()
        return hyExtAdapter.sendWup2(
          HyTafUI.EXT_CAPABILITY_UI,
          HyTafFuncName.DELIVER_ROOM_MSG_BY_UNIONID,
          req
        )
      } else {
        return Promise.reject(new ExtNotSupportError('这个接口仅支持主播调用'))
      }
    }
  }
  // 订阅相关
  async leadSubscribe(_: any, adapter: ExtAdapter): Promise<void> {
    const hyExtAdapter = adapter as HyExtAdapter
    if (hyExtAdapter.roomFollow.state) {
      return Promise.reject(
        new ExtParamInvalidError('当前用户已经订阅了当前直播间的主播')
      )
    } else {
      showLeadSubscribeModal({
        extMain: this.extMain,
        extEndpoint: this.extEndpoint,
        anchorName: hyExtAdapter.TTA.nick,
        container: await this.getModalContainer(adapter),
        onOk: () => {
          hyExtAdapter
            .subscribe()
            .catch((err) => this.logger.warn('订阅失败', { err: err.message }))
        },
        onCancel: () => {},
      })
      return Promise.resolve()
    }
  }
  // 礼物相关
  async leadGift(_: any, adapter: ExtAdapter): Promise<void> {
    const hyExtAdapter = adapter as HyExtAdapter
    showLeadGiftModal({
      extMain: this.extMain,
      extEndpoint: this.extEndpoint,
      container: await this.getModalContainer(adapter),
      onOk: () => {
        hyExtAdapter
          .leadGift()
          .catch((err) =>
            this.logger.warn('显示礼物面板失败', { err: err.message })
          )
      },
      onCancel: () => {},
    })
    return Promise.resolve()
  }
  onGiftChange(req: OnGiftChangeReq, adapter: ExtAdapter) {
    const { target, options } = req
    this.bus.on(
      BusType.GIFT,
      EventName.GIFT_CHANGE,
      (giftInfo) => {
        // TODO 根据options过滤
        this.extFrame.postMessageToBusiFrame(target, giftInfo, adapter)
      },
      true
    )
    return Promise.resolve()
  }
  offGiftChange(_: any, adapter: ExtAdapter) {
    this.bus.off(BusType.GIFT, EventName.GIFT_CHANGE)
    return Promise.resolve()
  }
  async sendGift(req: SendGiftReq, adapter: ExtAdapter): Promise<void> {
    return this.hySendGift(
      0,
      req.giftId,
      req.giftCount,
      adapter,
      false,
      '',
      this.extMain.extUuid,
      this.extEndpoint.extType
    )
  }
  // 弹幕相关
  async leadBarrage(_: any, adapter: ExtAdapter): Promise<void> {
    const hyExtAdapter = adapter as HyExtAdapter
    showLeadBarrageModal({
      extMain: this.extMain,
      extEndpoint: this.extEndpoint,
      container: await this.getModalContainer(adapter),
      onOk: () => {
        hyExtAdapter
          .leadBarrage()
          .catch((err) =>
            this.logger.warn('显示弹幕面板失败', { err: err.message })
          )
      },
      onCancel: () => {},
    })
    return Promise.resolve()
  }
  onBarrageChange(req: OnBarrageChangeReq, adapter: ExtAdapter) {
    const { target, options } = req
    this.bus.on(
      BusType.BARRAGE,
      EventName.BARRAGE_CHANGE,
      (barrageInfo) => {
        // TODO 根据options过滤
        this.extFrame.postMessageToBusiFrame(target, barrageInfo, adapter)
      },
      true
    )
    return Promise.resolve()
  }
  offBarrageChange(_: any, adapter: ExtAdapter) {
    this.bus.off(BusType.BARRAGE, EventName.BARRAGE_CHANGE)
    return Promise.resolve()
  }
  // UI相关
  // 存储相关
  // 用户相关
  async getUserInfo(req: any, adapter: ExtAdapter): Promise<GetUserInfoRsp> {
    await this.userAuth.getAuth(
      adapter,
      this.extEndpoint,
      await this.getModalContainer(adapter)
    )
    const hyAdapter = adapter as HyExtAdapter
    const userInfo = await hyAdapter.getHyUserInfo()
    const { unionId } = await wasmGenUnionId(
      userInfo.uid,
      this.extMain.authorAppId,
      adapter
    )
    const { userLevel } = await hyAdapter.getHyUserLevel()
    return {
      userNick: userInfo.userNick,
      userAvatarUrl: trimHttp(userInfo.userLogo),
      userLevel,
      userUnionId: unionId,
    }
  }
  // 直播间相关
  onOpenGuardianNotice(
    req: OnOpenGuardianNoticeReq,
    adapter: ExtAdapter
  ): Promise<void> {
    const { target } = req
    this.bus.on(
      BusType.GUARDIAN,
      EventName.OPEN_GUARDIAN_NOTICE,
      (notice) => {
        this.extFrame.postMessageToBusiFrame(target, notice, adapter)
      },
      true
    )
    return Promise.resolve()
  }
  offOpenGuardianNotice(_: any, adapter: ExtAdapter): Promise<void> {
    this.bus.off(BusType.GUARDIAN, EventName.OPEN_GUARDIAN_NOTICE)
    return Promise.resolve()
  }
  onOpenNobleNotice(
    req: OnOpenNobleNoticeReq,
    adapter: ExtAdapter
  ): Promise<void> {
    const { target } = req
    this.bus.on(
      BusType.NOBLE,
      EventName.OPEN_NOBLE_NOTICE,
      (notice) => {
        this.extFrame.postMessageToBusiFrame(target, notice, adapter)
      },
      true
    )
    return Promise.resolve()
  }
  offOpenNobleNotice(_: any, adapter: ExtAdapter): Promise<void> {
    this.bus.off(BusType.NOBLE, EventName.OPEN_NOBLE_NOTICE)
    return Promise.resolve()
  }
  onVipEnterBannerNotice(
    req: OnVipEnterBannerNoticeReq,
    adapter: ExtAdapter
  ): Promise<void> {
    const { target } = req
    this.bus.on(
      BusType.VIP,
      EventName.VIP_ENTER_BANNER_NOTICE,
      (notice) => {
        this.extFrame.postMessageToBusiFrame(target, notice, adapter)
      },
      true
    )
    return Promise.resolve()
  }
  offVipEnterBannerNotice(_: any, adapter: ExtAdapter): Promise<void> {
    this.bus.off(BusType.VIP, EventName.VIP_ENTER_BANNER_NOTICE)
    return Promise.resolve()
  }
  // 容器相关
  // 流相关
  // 文件相关
  async uploadFile(_: any, adapter: ExtAdapter): Promise<UploadFileRsp> {
    const hyExtAdapter = adapter as HyExtAdapter
    const { jwt } = await this.userAuth.getAuth(
      adapter,
      this.extEndpoint,
      await this.getModalContainer(adapter)
    )
    const inputFile = document.createElement('input')
    inputFile.setAttribute('type', 'file')
    return new Promise((resolve, reject) => {
      const handler = () => {
        const file = inputFile.files[0]
        if (file) {
          const fileExt = '.' + file.name.split('.').pop()
          const fileReader = new window.FileReader()
          fileReader.onload = async (evt) => {
            // @ts-ignore
            const contentMD5 = md5(evt.target.result)
            const MidExtCapability = await adapter.getJCE('MidExtCapability')
            const req: MidExtCapability.GetCommonFileUploadPolicyReq =
              new MidExtCapability.GetCommonFileUploadPolicyReq()
            req.tId = await adapter.getUserId()
            req.appId = this.extMain.authorAppId
            req.extUuid = this.extMain.extUuid
            req.pid = adapter.getStreamerUid()
            req.roomId = Number(adapter.getRoomId())
            req.request.componentTag = this.extEndpoint.extType
            req.request.extVersionTag = getExtVersionTag(
              this.extMain,
              this.extEndpoint
            )
            req.request.jwt = jwt
            req.request.sHostId = adapter.getHostId()
            // @ts-ignore
            req.auditAhead = 1 // 秩序审核形式 目前没有实现，只是预留字段
            req.bizName = 'huya_web_hyExtUpLoadFile' // 必填，业务名称，用于区分不同业务
            req.callbackUrl = '' // 尚未接秩序，默认为空
            const tafRsp: MidExtCapability.GetCommonFileUploadPolicyResp =
              await hyExtAdapter.sendWup2(
                HyTafUI.EXT_CAPABILITY_UI,
                HyTafFuncName.GET_COMMON_FILE_UPLOAD_POLICY,
                req
              )
            const formData = new window.FormData()
            formData.append(
              'key',
              tafRsp.uploadDir + contentMD5.slice(0, 16) + fileExt
            )
            formData.append('policy', tafRsp.policy)
            formData.append('OSSAccessKeyId', tafRsp.accessId)
            formData.append('success_action_status', '200')
            formData.append('callback', tafRsp.callback)
            formData.append('signature', tafRsp.signature)
            formData.append('file', file)
            const request = new XMLHttpRequest()
            request.open('POST', tafRsp.uploadHost)
            request.onreadystatechange = () => {
              if (request.readyState === XMLHttpRequest.DONE) {
                if (request.status === 200) {
                  const json = JSON.parse(request.responseText)
                  if (json && json.status === 0) {
                    resolve({ url: json.data.fileUrl })
                  } else {
                    reject(
                      new ExtInternalError(
                        json && json.msg ? json.msg : '上传错误，请联系管理员'
                      )
                    )
                  }
                } else {
                  reject(new ExtInternalError('上传错误，请联系管理员'))
                }
              }
            }
            request.send(formData)
          }
          fileReader.readAsArrayBuffer(file)
        }
        inputFile.remove()
      }
      inputFile.addEventListener('change', handler)
      inputFile.click()
    })
  }
  // 直播间行为相关
  async showEntrance(req: ShowEntranceReq, adapter: ExtAdapter): Promise<void> {
    const tId = await adapter.getUserId()
    const { lUid } = tId
    if (lUid === adapter.getStreamerUid()) {
      const { extTypes, countDown, cornerMarkId } = req
      const MidExtCapability = await adapter.getJCE('MidExtCapability')
      const tafReq: MidExtCapability.ShowEntranceReq =
        new MidExtCapability.ShowEntranceReq()
      const { jwt } = await this.userAuth.getAuth(
        adapter,
        this.extEndpoint,
        await this.getModalContainer(adapter)
      )
      tafReq.tId = tId
      tafReq.appId = this.extMain.authorAppId
      tafReq.extUuid = this.extMain.extUuid
      tafReq.pid = adapter.getStreamerUid()
      tafReq.request.componentTag = this.extEndpoint.extType
      tafReq.request.extVersionTag = getExtVersionTag(
        this.extMain,
        this.extEndpoint
      )
      tafReq.request.jwt = jwt
      tafReq.request.sHostId = adapter.getHostId()
      tafReq.extComponentTypeTag.value = [...extTypes.split(',')]
      tafReq.countDown = countDown
      tafReq.cornerMarkId = cornerMarkId || ''
      return (adapter as HyExtAdapter).sendWup2(
        HyTafUI.EXT_CAPABILITY_UI,
        HyTafFuncName.SHOW_ENTRANCE,
        tafReq
      )
    } else {
      return Promise.reject(new ExtNotSupportError('这个接口仅支持主播调用'))
    }
  }
  async hideEntrance(req: HideEntranceReq, adapter: ExtAdapter): Promise<void> {
    const tId = await adapter.getUserId()
    const { lUid } = tId
    if (lUid === adapter.getStreamerUid()) {
      const { extTypes } = req
      const MidExtCapability = await adapter.getJCE('MidExtCapability')
      const tafReq: MidExtCapability.CloseEntranceReq =
        new MidExtCapability.CloseEntranceReq()
      const { jwt } = await this.userAuth.getAuth(
        adapter,
        this.extEndpoint,
        await this.getModalContainer(adapter)
      )
      tafReq.tId = tId
      tafReq.appId = this.extMain.authorAppId
      tafReq.extUuid = this.extMain.extUuid
      tafReq.pid = adapter.getStreamerUid()
      tafReq.request.componentTag = this.extEndpoint.extType
      tafReq.request.extVersionTag = getExtVersionTag(
        this.extMain,
        this.extEndpoint
      )
      tafReq.request.jwt = jwt
      tafReq.request.sHostId = adapter.getHostId()
      tafReq.extComponentTypeTag.value = [...extTypes.split(',')]
      return (adapter as HyExtAdapter).sendWup2(
        HyTafUI.EXT_CAPABILITY_UI,
        HyTafFuncName.SHOW_ENTRANCE,
        tafReq
      )
    } else {
      return Promise.reject(new ExtNotSupportError('这个接口仅支持主播调用'))
    }
  }
  // 高级接口
  async advanceSendGift(
    req: AdvanceSendGiftReq,
    adapter: ExtAdapter
  ): Promise<void> {
    return this.hySendGift(
      0,
      req.giftId,
      req.giftCount,
      adapter,
      true,
      req.sourceType,
      this.extMain.extUuid,
      this.extEndpoint.extType
    )
  }
  async sendGiftToUser(
    req: SendGiftToUserReq,
    adapter: ExtAdapter
  ): Promise<void> {
    return this.hySendGift(
      req.uid,
      req.giftId,
      req.giftCount,
      adapter,
      true,
      req.sourceType,
      this.extMain.extUuid,
      this.extEndpoint.extType
    )
  }
  async onLinkStatusChange(req: OnLinkStatusChangeReq, adapter: ExtAdapter) {
    const { target } = req
    this.bus.on(
      BusType.WS,
      EventName.WS_STATUS_CHANGE,
      (wsStatus) => {
        this.extFrame.postMessageToBusiFrame(target, wsStatus, adapter)
      },
      true
    )
    return Promise.resolve()
  }
  // 友商接口
  // 环境相关
  // 虎牙视频相关
  // 播放器相关
  // 面板相关
  async disposal(_: any, adapter: ExtAdapter): Promise<void> {
    this.hidePanel(adapter)
    this.extFrame.unload(adapter)
  }
  // 秩序相关
  // OB相关
  // 后台相关
  async commonOperate(
    req: CommonOperateReq,
    adapter: ExtAdapter
  ): Promise<CommonOperateRsp> {
    const { key, param } = req
    const { jwt } = await this.userAuth.getAuth(
      adapter,
      this.extEndpoint,
      await this.getModalContainer(adapter)
    )
    const MidExtCommonOperate = await adapter.getJCE('MidExtCommonOperate')
    const tafReq: MidExtCommonOperate.CommonOperateReq =
      new MidExtCommonOperate.CommonOperateReq()
    tafReq.appId = this.extMain.authorAppId
    tafReq.extUuid = this.extMain.extUuid
    tafReq.functionType = key
    tafReq.paramJson = JSON.stringify(param)
    tafReq.pid = adapter.getStreamerUid()
    tafReq.request.extVersionTag = getExtVersionTag(
      this.extMain,
      this.extEndpoint
    )
    tafReq.request.jwt = jwt
    tafReq.request.sHostId = adapter.getHostId()
    tafReq.request.componentTag = this.extEndpoint.extType
    tafReq.tId = await adapter.getUserId()
    const tafRsp: MidExtCommonOperate.CommonOperateResp = await (
      adapter as HyExtAdapter
    ).sendWup2(
      HyTafUI.EXT_COMMON_OPERATE_UI,
      HyTafFuncName.COMMON_OPERATE,
      tafReq
    )
    return Promise.resolve(JSON.parse(unescapeHTML(tafRsp.responseJson)))
  }
  // 视图相关
  // PK相关
  // 连麦相关
  // websocket相关
  async wsConnect(
    req: WsConnectReq,
    adapter: ExtAdapter
  ): Promise<WsConnectRsp> {
    const { jwt } = await this.userAuth.getAuth(
      adapter,
      this.extEndpoint,
      await this.getModalContainer(adapter)
    )
    let { url } = req
    if (typeof url !== 'string' || !req.url) {
      return Promise.reject(new ExtParamInvalidError('url参数不合法'))
    } else {
      if (req.url.indexOf('?') >= 0) {
        url += '&jwt=' + encodeURIComponent(jwt)
      } else {
        url += '?jwt=' + encodeURIComponent(jwt)
      }
      return (adapter as HyExtAdapter).wsConnect(url)
    }
  }
  async wsSend(req: WsSendReq, adapter: ExtAdapter): Promise<void> {
    return (adapter as HyExtAdapter).wsSend(req.wsId, req.message)
  }
  async wsClose(req: WsCloseReq, adapter: ExtAdapter): Promise<void> {
    return (adapter as HyExtAdapter).wsClose(req.wsId, req.code, req.reason)
  }
  onCurrentStreamNameChange(
    req: OnCurrentStreamNameChangReq,
    adapter: ExtAdapter
  ): Promise<void> {
    const { target } = req
    this.bus.on(
      BusType.CURRENT_STREAM_NAME,
      EventName.CURRENT_STREAM_NAME_CHANGE,
      (notice) => {
        this.extFrame.postMessageToBusiFrame(target, notice, adapter)
      },
      true
    )
    return Promise.resolve()
  }
  offCurrentStreamNameChange(_: any, adapter: ExtAdapter): Promise<void> {
    this.bus.off(
      BusType.CURRENT_STREAM_NAME,
      EventName.CURRENT_STREAM_NAME_CHANGE
    )
    return Promise.resolve()
  }
  onNativeCompOffsetChange(
    req: OnNativeCompOffsetChangeReq,
    adapter: ExtAdapter
  ): Promise<void> {
    const {
      target,
      options: { key },
    } = req
    this.bus.on(
      BusType.NATIVE_COMP_OFFSET,
      `${EventName.NATIVE_COMP_OFFSET_CHANGE}_${key}`,
      (notice) => {
        this.extFrame.postMessageToBusiFrame(target, notice, adapter)
      }
    )
    return Promise.resolve()
  }
  offNativeCompOffsetChange(
    req: OffNativeCompOffsetChangeReq,
    adapter: ExtAdapter
  ): Promise<void> {
    const { key } = req
    this.bus.off(
      BusType.NATIVE_COMP_OFFSET,
      `${EventName.NATIVE_COMP_OFFSET_CHANGE}_${key}`
    )
    return Promise.resolve()
  }
  async isLogined(adapter: HyExtAdapter) {
    const userInfo = await adapter.getHyUserInfo()
    return userInfo.isLogined
  }
  async popupOpenCoinExchangePanel(
    req: PopupOpenCoinExchangePanelReq,
    adapter: ExtAdapter
  ): Promise<void> {
    if (!this.isLogined(adapter as HyExtAdapter)) {
      return Promise.reject(new ExtNotSupportError('请先登录'))
    }
    // 调用taf接口获取url
    const rsp = await service.getExchangePanelUrl(
      adapter,
      this.extMain,
      this.extEndpoint
    )
    // 显示弹窗
    return showOpenCoinExchangeModal({
      url: rsp.addressInfo.url,
      width: rsp.addressInfo.width,
      height: rsp.addressInfo.height,
      container: await this.getModalContainer(adapter),
      onClose: (closeType) => {
        this.postContextMessage(
          'openCoinPanelClosed',
          {
            openType: 'exchange',
            closeType,
          },
          adapter
        )
      },
      onOpenRecharge: () => {
        ;(adapter as HyExtAdapterInLiveRoom).openUrl(
          'huyaweb://liveRoomRecharge'
        )
      },
    })
  }
  async prePayOrder(
    req: PrePayOrderReq,
    adapter: ExtAdapter
  ): Promise<PrePayOrderRsp> {
    if (!this.isLogined(adapter as HyExtAdapter)) {
      return Promise.reject(new ExtNotSupportError('请先登录'))
    }
    // 调用taf接口获取
    const rsp = await service.prePayOrder(
      adapter,
      this.extMain,
      this.extEndpoint,
      req.outerPurchaseOrderId,
      req.price,
      req.productDetail,
      req.productId,
      req.productName,
      req.quantity,
      req.totalFee,
      req.nonce,
      req.signStr,
      req.signType,
      req.timeStamp
    )

    return {
      code: rsp.prePayOrderInfoResp.code,
      msg: rsp.prePayOrderInfoResp.msg,
      purchaseOrderId: rsp.prePayOrderInfoResp.purchaseOrderId,
      preOrderNonce: rsp.prePayOrderInfoResp.preOrderNonce,
    }
  }
  async requestOpenCoinConsume(
    req: RequestOpenCoinConsumeReq,
    adapter: ExtAdapter
  ): Promise<void> {
    if (!this.isLogined(adapter as HyExtAdapter)) {
      return Promise.reject(new ExtNotSupportError('请先登录'))
    }
    // 调用taf接口获取url
    const rsp = await service.requestConsume(
      adapter,
      this.extMain,
      this.extEndpoint,
      req.preOrderNonce,
      req.purchaseOrderId
    )
    // 显示弹窗
    return showRequestConsumeModal({
      url: rsp.addressInfo.url,
      width: rsp.addressInfo.width,
      height: rsp.addressInfo.height,
      container: await this.getModalContainer(adapter),
      onClose: (closeType) => {
        this.postContextMessage(
          'openCoinPanelClosed',
          {
            openType: 'consume',
            closeType,
          },
          adapter
        )
      },
      onOpenRecharge: () => {
        const hyExtAdpater = adapter as HyExtAdapterInLiveRoom
        hyExtAdpater.openUrl('huyaweb://liveRoomRecharge?panelType=hyb')
      },
    })
  }
  async queryUserOpenCoinBalance(
    _: any,
    adapter: ExtAdapter
  ): Promise<QueryUserOpenCoinBalanceRsp> {
    if (!this.isLogined(adapter as HyExtAdapter)) {
      return Promise.reject(new ExtNotSupportError('请先登录'))
    }
    // 调用taf接口获取
    const rsp = await service.queryUserBalance(
      adapter,
      this.extMain,
      this.extEndpoint
    )

    return {
      balance: Number(rsp.useableBalance),
    }
  }

  async chooseMedia(req: ChooseMediaReq, adapter: ExtAdapter): Promise<void> {
    // 生成input
    const input = document.createElement('input')
    input.type = 'file'
    input.multiple = true
    input.accept = 'image/*' // 限制只能选择图片文件

    /** 小程序传选图的最大分辨率，默认值6000 * 6000 */
    let maxResolution = 6000 * 6000
    /** 小程序传选图的最大容量，单位MB，默认值6 */
    let maxFileSize = 6

    try {
      const p = JSON.parse(req.options.faceDetectParam)
      maxResolution = Number(p.maxResolution) || maxResolution
      maxFileSize = Number(p.maxFileSize) || maxFileSize
    } catch (err) {}

    // 监听change事件
    input.addEventListener('change', (e) => {
      const fileList = (e.target as HTMLInputElement).files
      let completedLength = 0
      const notice: ChooseMediaNotice = {
        mediaList: [],
      }

      Array.from(fileList)
        .slice(0, req.options.count)
        .forEach((file) => {
          // 生成文件id
          const fileId = v4()

          let thumbnail = ''
          let faceDetectResult: 0 | 10 = 0

          const reader = new FileReader()
          reader.onload = (e) => {
            // 存储文件内容
            fileContentMap[fileId] = {
              file,
              contentMD5: md5(e.target.result as string),
            }
            const img = new Image()
            img.onload = () => {
              if (
                img.width * img.height > maxResolution ||
                file.size > maxFileSize * 1024 * 1024
              ) {
                // 图片分辨率过大或者图片太大
                faceDetectResult = 10
              } else {
                const canvas = document.createElement('canvas')
                const ctx = canvas.getContext('2d')
                const aspectRatio = img.width / img.height
                let tw = req.options.thumbnailConfig?.width || 100
                let th = req.options.thumbnailConfig?.height || 100
                if (req.options.thumbnailConfig.mode === 'contain') {
                  // 使用contain模式，缩放图片以适应缩略图区域
                  if (aspectRatio > 1) {
                    th = Math.round(tw / aspectRatio)
                  } else {
                    tw = Math.round(th * aspectRatio)
                  }
                } else if (req.options.thumbnailConfig.mode === 'cover') {
                  // 使用cover模式，裁剪图片以填满缩略图区域
                  if (aspectRatio > 1) {
                    tw = Math.round(th * aspectRatio)
                  } else {
                    th = Math.round(tw / aspectRatio)
                  }
                }

                // 画图
                canvas.width = req.options.thumbnailConfig?.width || 100
                canvas.height = req.options.thumbnailConfig?.height || 100
                ctx.drawImage(
                  img,
                  (canvas.width - tw) / 2,
                  (canvas.height - th) / 2,
                  tw,
                  th
                )

                // 生成缩略图
                thumbnail = canvas.toDataURL('image/png')
              }

              completedLength += 1
              notice.mediaList.push({
                fileId,
                thumbnail,
                size: file.size,
                width: img.width,
                height: img.height,
                type: 'image',
                faceDetectResult,
              })

              // 触发消息
              if (
                completedLength >= Math.min(fileList.length, req.options.count)
              ) {
                this.extFrame.postMessageToBusiFrame(
                  req.target,
                  notice,
                  adapter
                )
              }
            }
            img.src = e.target.result as string
          }
          reader.readAsDataURL(file)
        })
    })

    // 打开文件选择框
    input.click()

    return Promise.resolve()
  }
  async uploadFiles(req: UploadFilesReq, adapter: ExtAdapter): Promise<void> {
    const hyExtAdapter = adapter as HyExtAdapter
    const { jwt } = await this.userAuth.getAuth(
      adapter,
      this.extEndpoint,
      await this.getModalContainer(adapter)
    )
    req.fileIds.forEach((fileId) => {
      const content = fileContentMap[fileId]
      if (content) {
        const { file, contentMD5 } = content
        const fileExt = '.' + file.name.split('.').pop()
        const fileReader = new window.FileReader()
        fileReader.onload = async (evt) => {
          const MidExtCapability = await adapter.getJCE('MidExtCapability')
          const req: MidExtCapability.GetCommonFileUploadPolicyReq =
            new MidExtCapability.GetCommonFileUploadPolicyReq()
          req.tId = await adapter.getUserId()
          req.appId = this.extMain.authorAppId
          req.extUuid = this.extMain.extUuid
          req.pid = adapter.getStreamerUid()
          req.roomId = Number(adapter.getRoomId())
          req.request.componentTag = this.extEndpoint.extType
          req.request.extVersionTag = getExtVersionTag(
            this.extMain,
            this.extEndpoint
          )
          req.request.jwt = jwt
          req.request.sHostId = adapter.getHostId()
          // @ts-ignore
          req.auditAhead = 1 // 秩序审核形式 目前没有实现，只是预留字段
          req.bizName = 'huya_web_hyExtUpLoadFile' // 必填，业务名称，用于区分不同业务
          req.callbackUrl = '' // 尚未接秩序，默认为空
          const tafRsp: MidExtCapability.GetCommonFileUploadPolicyResp =
            await hyExtAdapter.sendWup2(
              HyTafUI.EXT_CAPABILITY_UI,
              HyTafFuncName.GET_COMMON_FILE_UPLOAD_POLICY,
              req
            )
          const formData = new window.FormData()
          formData.append(
            'key',
            tafRsp.uploadDir + contentMD5.slice(0, 16) + fileExt
          )
          formData.append('policy', tafRsp.policy)
          formData.append('OSSAccessKeyId', tafRsp.accessId)
          formData.append('success_action_status', '200')
          formData.append('callback', tafRsp.callback)
          formData.append('signature', tafRsp.signature)
          formData.append('file', file)
          const request = new XMLHttpRequest()
          request.open('POST', tafRsp.uploadHost)
          request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE) {
              if (request.status === 200) {
                const json = JSON.parse(request.responseText)
                if (json && json.status === 0) {
                  this.postContextMessage(
                    'uploadProgress',
                    {
                      res: 0,
                      url: json.data.fileUrl,
                      bytesTotal: file.size,
                      bytesSent: file.size,
                      fileId,
                    },
                    adapter
                  )
                } else {
                  this.postContextMessage(
                    'uploadProgress',
                    {
                      res: json?.status || 9999,
                      msg: json?.msg || '上传错误，请联系管理员',
                    },
                    adapter
                  )
                }
              } else {
                this.postContextMessage(
                  'uploadProgress',
                  { res: 9999, msg: '上传错误，请联系管理员' },
                  adapter
                )
              }
            }
          }
          request.send(formData)
        }
        fileReader.readAsArrayBuffer(file)
      } else {
        this.postContextMessage(
          'uploadProgress',
          { res: 9999, msg: `找不到id为${fileId}的文件记录，请刷新页面重试` },
          adapter
        )
      }
    })

    return Promise.resolve()
  }
  saveFiles(req: SaveFilesReq, adapter: ExtAdapter): Promise<void> {
    req.options.fileList.forEach((file) => {
      if (req.options.type === 'base64') {
        try {
          // 按base64保存
          const byteChars = atob(file.content)
          const byteNumbers = Array.from(
            { length: byteChars.length },
            (_, i) => {
              return byteChars.charCodeAt(i)
            }
          )
          const byteArray = new Uint8Array(byteNumbers)
          const blob = new Blob([byteArray], {
            type: 'application/octet-stream',
          })
          const url = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = file.name
          link.addEventListener('click', (evt) => {
            this.extFrame.postMessageToBusiFrame(
              req.target,
              {
                ...file,
                status: 0,
                statusMsg: '',
                localPath: '',
              },
              adapter
            )
            document.body.removeChild(link)
          })
          document.body.appendChild(link)
          link.click()
        } catch (err) {
          this.extFrame.postMessageToBusiFrame(
            req.target,
            {
              ...file,
              status: -1,
              statusMsg: err.message,
              localPath: '',
            },
            adapter
          )
        }
      } else {
        // 默认按url下载
        fetch(file.url)
          .then((rsp) => rsp.blob())
          .then((blob) => {
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = file.name
            link.addEventListener('click', (evt) => {
              this.extFrame.postMessageToBusiFrame(
                req.target,
                {
                  ...file,
                  status: 0,
                  statusMsg: '',
                  localPath: '',
                },
                adapter
              )
              document.body.removeChild(link)
            })
            document.body.appendChild(link)
            link.click()
          })
      }
    })
    return Promise.resolve()
  }
  async onSeiContentChange(req: OnSeiContentChangeReq, adapter: ExtAdapter) {
    const hyExtAdapterInLiveRoom = adapter as HyExtAdapterInLiveRoom
    const {
      target,
      options: { port },
    } = req

    if (
      hyExtAdapterInLiveRoom &&
      hyExtAdapterInLiveRoom.addDataChannelPortListener
    ) {
      this.bus.on(
        BusType.SEI_DATA,
        `${EventName.SEI_DATA_CHANGE}_${port}`,
        (notice) => {
          this.extFrame.postMessageToBusiFrame(
            target,
            { content: notice.data },
            adapter
          )
        }
      )
      hyExtAdapterInLiveRoom.addDataChannelPortListener(
        port,
        this.extMain.extUuid,
        this.extEndpoint.extType
      )
    } else {
      return Promise.reject(new ExtNotSupportError('当前环境不支持该接口'))
    }
  }
  async offSeiContentChange(req: OffSeiContentChangeReq, adapter: ExtAdapter) {
    const hyExtAdapterInLiveRoom = adapter as HyExtAdapterInLiveRoom
    const { port } = req

    if (
      hyExtAdapterInLiveRoom &&
      hyExtAdapterInLiveRoom.removeDataChannelPortListener
    ) {
      this.bus.off(BusType.SEI_DATA, `${EventName.SEI_DATA_CHANGE}_${port}`)
      hyExtAdapterInLiveRoom.removeDataChannelPortListener(
        port,
        this.extMain.extUuid,
        this.extEndpoint.extType
      )
    } else {
      return Promise.reject(new ExtNotSupportError('当前环墧不支持该接口'))
    }
  }
  async postBroadcastMessage(
    req: PostBroadcastMessageReq,
    adapter: ExtAdapter
  ) {
    const hyExtAdapter = adapter as HyExtAdapter
    hyExtAdapter.postBroadcastMessage(req.eventName, req.message)
  }
  async onBroadcastMessage(req: OnBroadcastMessageReq, adapter: ExtAdapter) {
    this.bus.on(
      BusType.BROADCAST,
      `${EventName.BROADCAST_TRIGGER}_${req.options.eventName}`,
      (message) => {
        this.extFrame.postMessageToBusiFrame(req.target, message, adapter)
      }
    )
  }
  async offBroadcastMessage(req: OffBroadcastMessageReq, adapter: ExtAdapter) {
    this.bus.off(
      BusType.BROADCAST,
      `${EventName.BROADCAST_TRIGGER}_${req.eventName}`
    )
  }
  async onLiveroomEffectStatusChange(
    req: OnLiveroomEffectStatusChangeReq,
    adapter: ExtAdapter
  ) {
    const hyExtAdapterInLiveRoom = adapter as HyExtAdapterInLiveRoom
    const {
      target,
      options: { type },
    } = req

    if (
      hyExtAdapterInLiveRoom &&
      hyExtAdapterInLiveRoom.addLiveroomEffectStatusChange
    ) {
      this.bus.on(
        BusType.LIVEROOM_EFFECT,
        `${EventName.LIVEROOM_EFFECT_CHANGE}_${type}`,
        (notice) => {
          this.extFrame.postMessageToBusiFrame(target, notice, adapter)
        }
      )
      hyExtAdapterInLiveRoom.addLiveroomEffectStatusChange(
        type,
        this.extMain.extUuid,
        this.extEndpoint.extType
      )
    } else {
      return Promise.reject(new ExtNotSupportError('当前环境不支持该接口'))
    }
  }
  async offLiveroomEffectStatusChange(
    req: OffLiveroomEffectStatusChangeReq,
    adapter: ExtAdapter
  ) {
    const hyExtAdapterInLiveRoom = adapter as HyExtAdapterInLiveRoom
    const { type } = req

    if (
      hyExtAdapterInLiveRoom &&
      hyExtAdapterInLiveRoom.delLiveroomEffectStatusChange
    ) {
      this.bus.off(
        BusType.LIVEROOM_EFFECT,
        `${EventName.LIVEROOM_EFFECT_CHANGE}_${type}`
      )
      hyExtAdapterInLiveRoom.delLiveroomEffectStatusChange(
        type,
        this.extMain.extUuid,
        this.extEndpoint.extType
      )
    } else {
      return Promise.reject(new ExtNotSupportError('当前环墧不支持该接口'))
    }
  }
  async getLiveroomEffectStatus(
    req: GetLiveroomEffectStatusReq,
    adapter: ExtAdapter
  ) {
    return (adapter as HyExtAdapterInLiveRoom).ttpCallWithRes(
      TTPCallFuncName.GET_LIVEROOM_EFFECT_STATUS,
      req
    )
  }
  async sendActivityGift(req: SendActivityGiftReq, adapter: ExtAdapter) {
    return (adapter as HyExtAdapterInLiveRoom).ttpCallAsync(
      TTPCallFuncName.SEND_EXT_ACTIVITY_GIFT,
      req
    )
  }
  async getDynamicConfigString(
    req: GetDynamicConfigStringReq,
    adapter: ExtAdapter
  ): Promise<GetDynamicConfigStringRsp> {
    if (
      this.extEndpoint.extType === 'web_popup' &&
      req.key === 'key_pub_popup_using_new_feature'
    ) {
      return { value: '1' }
    } else {
      return (adapter as HyExtAdapterInLiveRoom).ttpCallAsync(
        TTPCallFuncName.GET_DYNAMIC_CONFIG_STRING,
        req
      )
    }
  }
}
